export const LAUNCHDARKLY_CLIENT_ID =
  import.meta.env.VITE_LAUNCHDARKLY_CLIENT_ID || "";

export enum FeatureFlags {
  RemoteTestFlag = "remoteTestFlag",
  PhlebotomyLanguageSelect = "phlebotomyLanguageSelect",
  BetaFeature = "betaFeature",
  FetalAntigenExpansion = "fetalAntigenExpansion",
  FetalAntigenLateAdd = "fetalAntigenLateAdd",
  PortalStatus = "portalStatus",
  ProviderMfa = "providerMfa",
  ProviderCfc = "providerCfc",
  ProviderMslOrdering = "providerMslOrdering",
  SmallAddOnButton = "smallAddOnButton",
  ProviderGlobalSearch = "provider-global-search",
  ProviderElectronicOrderEdit = "provider-electronic-order-edit",
  ShipKitToPatient = "ship-kit-to-patient",
  ProviderAdvocacy = "provider-advocacy",
  CarrierScreenAttachmentVariant = "carrier-screen-attachment-variant",
}
